export default "__VITE_ASSET__lbVTmCet__"